/* IGNIERE About Us §222（2026-10-01）── 動く扉・ヘッダーの色・出現・ゆっくりした位置の変化
 *
 * 動く扉：縦に長い節の中で窓（sticky）が画面に貼り付き、スクロールの進みで 3 枚が入れ替わる。
 *   節の高さ・区切り・溶ける区間は Film.prototype.apply の上のコメント（2026-10-03 代表と決めた値）。
 *   印（data-ig-film-on・data-ig-rv-armed）は節の直後のインラインの script が初回の描画前に付ける
 *   （defer を待つと低速回線で作りが後から入れ替わり、見出しの位置がずれて見えた）。ここは進み具合の更新だけ。
 *   PC だけ 1.000→1.025 のごく小さな寄り。スナップ・強制送りはしない（速さも向きも読み手のもの）。
 * スクロールの出所：Horizon は PC（≥990px）で .page-wrapper、SP で window。
 *   getBoundingClientRect() はどちらでも画面上の位置を返すので、出所を判定しない（旧 §180 と同じ）。
 * 床：動きを減らす設定・JS 無効では、3 枚を縦に並べて全部見える（CSS 側の既定）。
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var pc = window.matchMedia('(min-width: 990px)');

  function clamp01(v) { return v < 0 ? 0 : (v > 1 ? 1 : v); }
  function smooth(v) { v = clamp01(v); return v * v * (3 - 2 * v); }

  /* ── 動く扉 ── */
  function Film(root) {
    this.root = root;
    this.frames = root.querySelectorAll('[data-ig-frame]');
    this.count = root.querySelector('[data-ig-count]');
    this.stage = root.querySelector('.ig-ab2__film-stage');
    this.last = -1;
    this.shown = 1;
    if (this.frames.length < 2) return;
    /* 印は通常インラインの script が付け済み（二重に付けない）。テーマエディターの再描画などで無い時だけ付ける */
    if (!root.hasAttribute('data-ig-film-on')) root.setAttribute('data-ig-film-on', '');
    this.update();
  }

  Film.prototype.update = function () {
    this.apply(this.progress());
    this.fadeType();
  };

  /* 縦書きの見出しが透明なヘッダーの下へ潜り込む前に消す（990 幅で NEW ARRIVAL に重なった・Codex 検品）。
     見出しの上端がヘッダーの下端＋24px に来たら薄れ始め、＋4px で消える（位置に連動＝逆スクロールで戻る）。
     初期位置はヘッダーの下 32px（スマホ）〜40px 以上（PC）なので、止まっている間は薄れない */
  Film.prototype.fadeType = function () {
    var type = this.type || (this.type = this.root.querySelector('.ig-ab2__film-type'));
    if (!type) return;
    var h = document.querySelector('.header-section') || document.querySelector('header');
    var hb = h ? h.getBoundingClientRect().bottom : 0;
    var top = type.getBoundingClientRect().top;
    var v = clamp01((top - (hb + 4)) / 20);
    this.root.style.setProperty('--ig-type-fade', v.toFixed(3));
    /* 下端の 3 つ（札・続きを読む・位置）も同じ理由で、扉が上へ抜ける時にヘッダーへ届く前に消す（検品 N1 の同型） */
    /* 3 つのうち一番上に来るもの（押せる高さ 44px を持つ「続きを読む」）の上端で測る */
    var foots = this.foots || (this.foots = this.root.querySelectorAll('.ig-ab2__kicker, .ig-ab2__next, .ig-ab2__count'));
    if (foots.length) {
      var ft = Infinity;
      for (var i = 0; i < foots.length; i++) {
        var fr = foots[i].getBoundingClientRect();
        if (fr.height) ft = Math.min(ft, fr.top);
      }
      this.root.style.setProperty('--ig-foot-fade', clamp01((ft - (hb + 4)) / 20).toFixed(3));
    }
  };

  /* 分母は窓（sticky）の実高。CSS は svh、window.innerHeight は Safari のアドレスバーの伸縮で変わる＝
     両者がずれると p が 1 に届かない／早く届く（2026-10-03）。窓の実高なら CSS と同じ物差しになる */
  Film.prototype.progress = function () {
    var r = this.root.getBoundingClientRect();
    var vh = this.stage ? this.stage.getBoundingClientRect().height : (window.innerHeight || document.documentElement.clientHeight);
    return clamp01(-r.top / Math.max(r.height - vh, 1));
  };

  /* 写真が読み込み済みか。未読込の写真へは切り替えない（設計図_Codex.md:146）＝届くまで前の絵とカウンターを保つ */
  function ready(fig) {
    var img = fig && fig.querySelector('img');
    if (!img) return true;
    return img.complete && img.naturalWidth > 0;
  }

  /* 各枚の見え方（0〜1）。
     代表と決めた値（2026-10-03）：1 段階＝100svh（1 スワイプで 1 段階）・溶ける区間＝1 段階の 20%（切り替わりの前後 10svh）。
     節の高さ h＝350svh（--ig-film-h・代表の実機で 250/300/350 を比べ 350 が自然＝2026-10-03）・窓 100svh ＝送り (h−100)＝250svh を p 0→1 に写す。
     切り替わりは送りの 50svh と 150svh＝p 0.25 と 0.75（間隔 100svh＝1 段階。1 枚目は 50svh 保ち、
     3 枚目は窓が流れ出すまでの 50svh＋流れ出す間も見える）。溶ける区間は前後 10svh ＝ 10 ÷ 200 ＝ p で ±0.05。
     ?ig_film= で h を替えても cuts と W は比率のまま＝切り替わりの間隔と溶ける区間は (h−100) に比例して伸び縮みする */
  var CUTS = [0.25, 0.75], W = 0.05;

  Film.prototype.apply = function (p) {
    var cuts = CUTS, w = W;
    var o2 = smooth((p - (cuts[0] - w)) / (2 * w));
    var o3 = smooth((p - (cuts[1] - w)) / (2 * w));
    /* 未読込の枚は 0 のまま（3 枚目が先に届いても 2 枚目が未読込なら、3 枚目も待つ＝順番を飛ばさない） */
    var ok2 = ready(this.frames[1]), ok3 = ok2 && ready(this.frames[2]);
    if (!ok2) o2 = 0;
    if (!ok3) o3 = 0;
    var ops = [1, o2, o3];
    for (var i = 0; i < this.frames.length && i < 3; i++) {
      this.frames[i].style.opacity = i === 0 ? 1 : ops[i].toFixed(3);
    }
    var scale = pc.matches ? (1 + 0.025 * p) : 1;
    this.root.style.setProperty('--ig-film-scale', scale.toFixed(4));
    var n = p < cuts[0] || !ok2 ? 1 : (p < cuts[1] || !ok3 ? 2 : 3);
    if (n !== this.last && this.count) { this.count.textContent = '0' + n; this.last = n; }
  };

  /* 写真が届いた瞬間に見え方を引き直す（読み手が止まっていても、届いたら今の位置の絵へ溶ける）。
     止まっている所で急に絵が替わらないよう、追いつく時だけ 0.5 秒かけて溶かす（以後はスクロールに直結へ戻す） */
  Film.prototype.watch = function (cb) {
    var self = this;
    function caught() {
      for (var j = 1; j < self.frames.length; j++) self.frames[j].style.transition = 'opacity .5s ease';
      clearTimeout(self.easeT);
      self.easeT = setTimeout(function () {
        for (var j = 1; j < self.frames.length; j++) self.frames[j].style.transition = '';
      }, 600);
      cb();
    }
    for (var i = 1; i < this.frames.length; i++) {
      var img = this.frames[i].querySelector('img');
      if (img && !ready(this.frames[i])) img.addEventListener('load', caught, { once: true });
    }
  };


  /* ── ヘッダーの色：暗い面（data-ig-dark）がヘッダーの帯を丸ごと覆っている時だけ明色（§222-13） ──
     旧判定（帯の中心をまたぐ＝§184-2）では、扉の下端が帯の中ほどまで上がった時にヘッダーの下半分が紙色の面に乗り、
     白い印が紙色の上で消えた（カートの印で対比 1.08・実測 2026-10-02）。紙色のヘッダーは暗い面の上でも読めるので、
     少しでも紙色の面がかかったら紙色に戻すのが安全な側 */
  function tone(host) {
    var darks = host.querySelectorAll('[data-ig-dark]');
    var on = null;
    function headerBand() {
      var h = document.querySelector('.header-section') || document.querySelector('header');
      if (!h) return [0, 68];
      var r = h.getBoundingClientRect();
      return [r.top, r.bottom];
    }
    function tick() {
      var b = headerBand(), dark = false;
      for (var i = 0; i < darks.length; i++) {
        var r = darks[i].getBoundingClientRect();
        if (r.top <= b[0] + 1 && r.bottom >= b[1] - 1) { dark = true; break; }
      }
      if (dark !== on) {
        on = dark;
        if (dark) host.setAttribute('data-ig-ondark', '');
        else host.removeAttribute('data-ig-ondark');
      }
    }
    return tick;
  }

  /* ── ヘッダーの裏の暗がりを、扉が上へ流れた分だけ下へずらす（§222-13） ──
     扉の窓は貼り付きを終えると頁と一緒に上へ流れる。暗がりが写真の上端に付いたままだと一緒に抜け、
     明るい窓がヘッダーの真下に来てロゴとナビが埋もれた。窓の中に収まる範囲で、常にヘッダーの真下に置く。
     動きを減らす設定（3 枚が縦に並ぶ）でも同じ理由で効かせる */
  function release(host) {
    var stages = host.querySelectorAll('.ig-ab2__film-stage');
    return function () {
      for (var i = 0; i < stages.length; i++) {
        if (!stages[i].querySelector('.ig-ab2__film-hscrim')) continue;
        var r = stages[i].getBoundingClientRect();
        /* 上限＝窓の下端からヘッダーの帯の高さ分だけ手前（そこから先はヘッダーが紙色に戻る）。はみ出す分は窓の枠で切る */
        var h = document.querySelector('.header-section') || document.querySelector('header');
        var hb = h ? h.getBoundingClientRect().height : 68;
        var v = Math.min(Math.max(-r.top, 0), Math.max(r.height - hb, 0));
        stages[i].style.setProperty('--ig-release', v.toFixed(1) + 'px');
        /* §286 窓は切り取りを持たない＝窓の下端より下へ出た暗がりの分だけ、暗がり自身を下から切る */
        var hs = stages[i].querySelector('.ig-ab2__film-hscrim');
        var over = hs ? Math.max(v + hs.offsetHeight - r.height, 0) : 0;
        stages[i].style.setProperty('--ig-hclip', over.toFixed(1) + 'px');
      }
    };
  }

  /* ── 出現（§185 の data-ig-rv を流用）：読む位置に来たら 1 回だけ ── */
  /* 印（data-ig-rv-armed）は節の直後のインラインの script が初回の描画前に付ける（後から付けると、見えていた物が一度消えてから現れる） */
  function reveal(host) {
    var targets = host.querySelectorAll('[data-ig-rv]');
    function disarm() { host.removeAttribute('data-ig-rv-armed'); if (io) io.disconnect(); }
    var io = null;
    if (!('IntersectionObserver' in window) || reduced.matches || !targets.length) { disarm(); return; }
    if (!host.hasAttribute('data-ig-rv-armed')) host.setAttribute('data-ig-rv-armed', '');
    /* 画面の下 32% に入っただけでは発火しない＝読む位置まで来てから（§185-3） */
    io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        if (!es[i].isIntersecting) continue;
        es[i].target.setAttribute('data-ig-rv-in', '');
        io.unobserve(es[i].target);
      }
    }, { rootMargin: '0px 0px -32% 0px', threshold: 0.12 });
    for (var i = 0; i < targets.length; i++) io.observe(targets[i]);
    /* 読んでいる途中で「動きを減らす」を ON にしたら、待っている物も全部すぐ見せる */
    var onChange = function (e) { if (e.matches) disarm(); };
    if (reduced.addEventListener) reduced.addEventListener('change', onChange);
    else if (reduced.addListener) reduced.addListener(onChange);
  }

  /* ── 右の写真だけ、最大 24px の遅い位置の変化（PC のみ） ── */
  function drift(host) {
    var els = host.querySelectorAll('[data-ig-drift]');
    if (!els.length) return function () {};
    return function () {
      if (pc.matches && !reduced.matches) {
        var vh = window.innerHeight;
        for (var i = 0; i < els.length; i++) {
          var r = els[i].getBoundingClientRect();
          var t = clamp01((vh - r.top) / (vh + r.height));
          els[i].style.setProperty('--ig-drift', ((0.5 - t) * 48).toFixed(1) + 'px');
        }
      }
    };
  }

  function boot() {
    var host = document.querySelector('[data-ig-ab2]');
    if (!host) return;
    window.igAbFilmBooted = true; /* インラインの script の床（load で印を外す）を止める合図 */
    var films = [];
    if (!reduced.matches) {
      var nodes = host.querySelectorAll('[data-ig-film]');
      for (var i = 0; i < nodes.length; i++) films.push(new Film(nodes[i]));
    }
    var toneTick = tone(host);
    var driftTick = drift(host);
    var releaseTick = release(host);
    reveal(host);

    /* スクロールの出所（PC＝.page-wrapper／SP＝window）を問わず、捕捉段階で 1 本だけ聞く。
       動いた時だけ 1 フレームで全部を更新する（止まっている間は何も回さない）。 */
    var queued = false;
    function frame() {
      queued = false;
      for (var j = 0; j < films.length; j++) if (films[j].frames && films[j].frames.length > 1) films[j].update();
      releaseTick();
      toneTick();
      driftTick();
    }
    function schedule() { if (!queued) { queued = true; window.requestAnimationFrame(frame); } }
    /* §286 開いた時に固定した 1svh（--ig-svh）の測り直し。
       指の端末は画面の向きが変わった時だけ。LINE などは帯の伸び縮みのたびに高さも幅もわずかに変わり、
       幅で判定しても測り直しが走って写真が 6% 拡大・縮小した（代表の画面収録 2026-10-08）。
       マウスの端末（PC で窓の大きさを変えた時）は今までどおり追従する */
    function remeasure() {
      var d = document.createElement('div');
      d.style.cssText = 'position:absolute;top:0;visibility:hidden;height:100svh;width:1px';
      document.body.appendChild(d);
      var px = d.offsetHeight || window.innerHeight; d.remove();
      if (px) host.style.setProperty('--ig-svh', px / 100 + 'px');
    }
    var portrait = window.matchMedia('(orientation: portrait)');
    if (window.matchMedia('(pointer: coarse)').matches) {
      var onTurn = function () { setTimeout(remeasure, 300); }; /* 回転の後、帯が落ち着いてから測る */
      if (portrait.addEventListener) portrait.addEventListener('change', onTurn);
      else if (portrait.addListener) portrait.addListener(onTurn);
    } else {
      window.addEventListener('resize', remeasure, { passive: true });
    }
    document.addEventListener('scroll', schedule, { capture: true, passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    for (var k = 0; k < films.length; k++) if (films[k].watch) films[k].watch(schedule);
    frame();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
